/**
 * @file    WorkerDebugDialog.css - Styles the worker debug panel component.
 *
 * @author  Wes Garland <wes@distributive.network>
 *          Kirill Kirnichansky <kirill@distributive.network>
 * @date    July 2022
 */

BODY DIV#_dbgsrc
{
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity ease-in 200ms;
  height: 0;
}

BODY[idkfa="enabled"] DIV#_dbgsrc
{
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  height: initial;
}

DIV#_dbgsrc
{
  border: 1px solid #aaa;
  padding: 5px;
  border-radius: 5px;
  background: rgba(240,240,240,0.9);
  position: fixed;
  bottom: 100px;
  left: 200px;
  width: 40em;
  z-index: 1000;
}

DIV#_dbgsrc DIV#_cgdbginput
{
  padding-top: 1em;
  width: 20em;
  text-align: right;
  float: left;
}

DIV#_dbgsrc DIV#_cgdbgoutput
{
  padding-top: 1em;
  text-align: center;
  height: 150px;
  overflow-y: scroll;
}

DIV#_dbgsrc DIV#_cgdbgoutput li
{
  height: 20px;
}

DIV#_dbgsrc DIV#_cgdbgoutput li:hover
{
  color: green;
  cursor: pointer;
}

DIV#_dbgsrc DIV#_cgdbgclose
{
  line-height: 0.8em;
  position: absolute;
  padding: 1px 0.1em 0 0.1em;
  right: 0.2em;
  text-align: right;
  margin: -1em 0 0 0;
  border: 1px solid #999;
  background: white;
  cursor: pointer;
}

DIV#_dbgsrc FORM
{
  display: block;
}

DIV#_dbgsrc SELECT
{
  position: relative;
  width: 17em;
  display: inline-block;
}

DIV#_dbgsrc DIV#_dcpdbg > DIV
{
  display: inline-block;
  text-align: center;
}
